{
  "buyToken": "Mua {{token}}",
  "sellToken": "Bán {{token}}",
  "viewOrder": "Xem lệnh",
  "requestedAmount": "Số tiền yêu cầu",
  "actualPaidAmount": "Số tiền đã thanh toán thực tế",
  "transactionQuantity": "Số lượng giao dịch",
  "completedListedQuantity": "Đã khớp/đã niêm yết",
  "fastTrack": "Giao dịch nhanh",
  "status": "Trạng thái: {{status}}",
  "noOrders": "Chưa có lệnh",
  "orderDetails": "Chi tiết lệnh",
  "matchedOrders": "Lệnh đã ghép",
  "listing": "Đang niêm yết",
  "transactionCompleted": "Giao dịch hoàn tất",
  "cancelling": "Đang hủy",
  "transactionCancelled": "Giao dịch đã hủy",
  "transactions": "Lệnh giao dịch",
  "cancelListing": "Hủy niêm yết",
  "orderInformation": "Thông tin lệnh",
  "systemOrderNumber": "Mã lệnh hệ thống",
  "sourceOrder": "Lệnh nguồn",
  "createdAt": "Thời gian tạo",
  "completedAt": "Thời gian hoàn tất",
  "price": "Đơn giá",
  "listedQuantity": "Tổng số lượng niêm yết",
  "minimumTransaction": "Số lượng tối thiểu mỗi giao dịch",
  "completedQuantity": "Số lượng đã khớp",
  "processingQuantity": "Số lượng đang giao dịch",
  "remainingQuantity": "Số lượng còn lại",
  "refundedQuantity": "Số lượng đã hoàn",
  "receivedAmount": "Đã nhận",
  "expectedTotal": "Tổng dự kiến nhận",
  "paymentMethods": "Phương thức nhận tiền",
  "seller": "Người bán",
  "buyer": "Người mua",
  "specialParty": "Đối tác đặc biệt",
  "paymentAmount": "Số tiền thanh toán",
  "paymentMethod": "Phương thức thanh toán",
  "expectedReceived": "Dự kiến nhận",
  "revising": "(Đang chỉnh sửa)",
  "sellerReceivingInformation": "Thông tin nhận tiền của người bán",
  "buyerPaymentInformation": "Thông tin thanh toán của người mua",
  "name": "Họ tên",
  "bankName": "Ngân hàng",
  "bankBranch": "Chi nhánh ngân hàng",
  "bankAccountNumber": "Số tài khoản ngân hàng",
  "account": "Tài khoản {{method}}",
  "receivingCode": "Mã nhận tiền {{method}}",
  "modificationRequest": "Yêu cầu thay đổi thông tin",
  "originalQuantity": "Số lượng trước khi sửa",
  "originalAmount": "Số tiền trước khi sửa",
  "updatedQuantity": "Số lượng sau khi sửa",
  "updatedAmount": "Số tiền sau khi sửa",
  "sellerPaymentProof": "Chứng từ thanh toán của người bán",
  "imageFormatInvalid": "Định dạng ảnh không hợp lệ",
  "imageTooLarge": "Ảnh vượt quá giới hạn 5 MB",
  "cancelOrder": "Hủy lệnh",
  "cancelOrderVideoInstruction": "Nếu muốn hủy lệnh này, hãy quay và tải lên video sao kê ngân hàng trực tuyến, trong đó phải thấy rõ thời gian hiện tại.",
  "cancelOrderVideoSteps": "Mở cửa hàng ứng dụng, tìm và mở ứng dụng ngân hàng, rồi vào thông tin thẻ và lịch sử giao dịch.",
  "back": "Quay lại",
  "confirmCancel": "Xác nhận hủy",
  "paymentInProgress": "Đang thanh toán",
  "buyerPaymentInProgress": "Người mua đang thanh toán",
  "paymentTimeRemaining": "Thời gian thanh toán còn lại",
  "buyerPaymentInstruction": "Thanh toán theo thông tin nhận tiền của người bán, tải chứng từ lên rồi nhấn “Tôi đã thanh toán”.",
  "waitingForBuyerPayment": "Đang chờ người mua thanh toán.",
  "uploadPaymentProof": "Tải chứng từ thanh toán",
  "paymentProofUploadHint": "Tải từ 1 đến 3 ảnh, mỗi ảnh không quá 5 MB. Hỗ trợ JPG, JPEG, PNG.",
  "paid": "Tôi đã thanh toán",
  "startAppeal": "Khiếu nại",
  "awaitingSellerRelease": "Chờ người bán giải phóng token",
  "awaitingRelease": "Chờ giải phóng token",
  "releaseTimeRemaining": "Thời gian giải phóng còn lại",
  "releaseAfterConfirmation": "Token sẽ được giải phóng sau khi xác nhận đã nhận tiền.",
  "buyerPaidReleaseInstruction": "Người mua đã thanh toán. Hãy xác nhận rồi nhấn “Giải phóng token”.",
  "buyerPaidConfirmation": "Người mua đã thanh toán. Hãy kiểm tra đã nhận chuyển khoản từ người thanh toán bên dưới, sau đó xác nhận nhận tiền và giải phóng token.",
  "appealAmountMismatch": "Khiếu nại/số tiền không khớp",
  "confirmReceiptAndRelease": "Xác nhận nhận tiền và giải phóng token",
  "sellerReleasedToken": "Người bán đã giải phóng token",
  "respondToOrderChange": "Phản hồi thay đổi lệnh",
  "agreeToOrderChange": "Bạn có đồng ý thay đổi lệnh này không?",
  "disagree": "Không đồng ý",
  "agree": "Đồng ý",
  "revisingOrder": "Đang chỉnh sửa",
  "sellerRequestedOrderChange": "Số tiền người bán thực nhận không khớp với dự kiến và đã yêu cầu thay đổi lệnh. Hãy phản hồi yêu cầu thay đổi.",
  "orderChangeSubmitted": "Bạn đã gửi yêu cầu thay đổi lệnh. Vui lòng chờ người mua phản hồi.",
  "sellerCancelling": "Người bán đang hủy",
  "orderCancellationInProgress": "Lệnh đang được hủy. Vui lòng chờ, chúng tôi sẽ thông báo sau khi xác nhận.",
  "appealOrder": "Khiếu nại lệnh",
  "appealOrderDescription": "Sau khi khiếu nại, bộ phận hỗ trợ sẽ tham gia xử lý giao dịch này cho đến khi kết thúc.",
  "confirmAppeal": "Xác nhận khiếu nại",
  "confirmCancelOrder": "Bạn có chắc muốn hủy lệnh này không?",
  "unlistOrder": "Gỡ niêm yết",
  "lotteryFailed": "Rút thăm thất bại, vui lòng thử lại sau.",
  "lotteryTicketLoadFailed": "Không thể tải vé rút thăm, vui lòng thử lại sau.",
  "drawing": "Đang rút thăm…",
  "draw": "Chạm để rút thăm",
  "finishDrawing": "Hoàn tất",
  "ticketUnavailable": "Vé rút thăm này đã được sử dụng hoặc không còn hiệu lực.",
  "congratulations": "Chúc mừng bạn nhận được",
  "tokenRedEnvelope": "Lì xì {{token}}",
  "redEnvelopeImage": "Hình ảnh lì xì",
  "redEnvelopeDelivered": "Số tiền lì xì đã được cộng vào số dư ví của bạn.",
  "noPrize": "Tiếc quá, bạn vừa lỡ giải lớn! Thử lại nhé!",
  "appealInProgress": "Đang khiếu nại",
  "appealSupportInstruction": "Hãy chọn Liên hệ hỗ trợ ở góc trên bên phải để trao đổi với bộ phận hỗ trợ.",
  "paymentProof": "Bằng chứng thanh toán",
  "fastTrackDetails": "Chi tiết giao dịch nhanh"
}
